<template>
  <div>
    <b-modal header-bg-variant="primary" header-text-variant="white" v-if="typeof orgs.current != 'undefined'" size="lg" id="modal-orgs" centered ok-disabled
             title="Организация" cancel-title-html="Закрыть" button-size="sm">
      <b-input hidden v-model="orgs.current.id"></b-input>
      <div class="row">
        <div class="col-md-6">
          <h5>Основная информация</h5>

          <div class="form-group">
            <b-input size="sm" v-model="orgs.current.name" placeholder="Наименование организации"></b-input>
            <small class="form-text text-muted">Укажите полное наименование организации или индивидуального
              предпринимателя
            </small>
          </div>

          <div class="form-group">
            <b-input size="sm" v-model="orgs.current.iinbin" v-mask="'############'"
                     placeholder="ИИН или БИН организации"></b-input>
            <small class="form-text text-muted">Укажите ИИН или БИН</small>
          </div>

          <div class="form-group">
            <Enums :type="'enum'" :name="'orgtype'" v-model="orgs.current.type"></Enums>
            <small class="form-text text-muted">Физическое или юридическое лицо</small>
          </div>

          <div class="form-group">
            <Enums :type="'enum'" :name="'orgmode'" v-model="orgs.current.mode"></Enums>
            <small class="form-text text-muted">Режим налогообложения</small>
          </div>

          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <b-input size="sm" v-model="orgs.current.kbe" placeholder="Код бенефициара"></b-input>
                <small class="form-text text-muted">КБе</small>
              </div>
            </div>
            <div class="col-8"></div>
          </div>



        </div>
        <div class="col-md-6">
          <h5>Банковские реквизиты</h5>

          <div class="form-group">
            <Enums :type="'local'" :name="'banks'"
                   v-model="orgs.current.bank_id"></Enums>
            <small class="form-text text-muted">Выберите банк</small>
          </div>

          <div class="form-group">
            <b-input size="sm" v-model="orgs.current.iik" placeholder="20-значный номер счета"></b-input>
            <small class="form-text text-muted">Введите ИИК</small>
          </div>

          <div class="form-group">
            <b-input size="sm" v-model="orgs.current.iik_salary" placeholder="20-значный номер счета"></b-input>
            <small class="form-text text-muted">Введите номер счета поступления зарплаты в банк</small>
          </div>

          <h5>Руководство</h5>

          <div class="form-group">
            <b-input size="sm" v-model="orgs.current.chief" placeholder="Руководитель организации"></b-input>
            <small class="form-text text-muted">Ф.И.О. руководителя</small>
          </div>

          <div class="form-group">
            <b-input size="sm" v-model="orgs.current.accountant"
                     placeholder="Главный бухгалтер (при наличии)"></b-input>
            <small class="form-text text-muted">Ф.И.О. главного бухгалтера</small>
          </div>
        </div>
        <div class="col-md-12">
          <h5>Почтовый адрес</h5>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <b-input size="sm" v-model="orgs.current.zip" placeholder="Индекс"></b-input>
                <small class="form-text text-muted">Введите почтовый индекс</small>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <b-input size="sm" v-model="orgs.current.country" placeholder="Страна"></b-input>
                <small class="form-text text-muted">Введите страну</small>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <b-input size="sm" v-model="orgs.current.region" placeholder="Область"></b-input>
                <small class="form-text text-muted">Введите область</small>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <b-input size="sm" v-model="orgs.current.city" placeholder="Город, поселок, село"></b-input>
                <small class="form-text text-muted">Введите населенный пункт</small>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <b-input size="sm" v-model="orgs.current.address" placeholder="Почтовый адрес"></b-input>
                <small class="form-text text-muted">Введите почтовый адрес (улица, микрорайон, дом, квартира, офис)</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template v-slot:modal-footer="{cancel}">
        <b-button variant="primary" size="sm" @click="regOrgs('save')"><span class="mdi mdi-content-save"></span> Сохранить</b-button>
        <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span> Закрыть</b-button>
      </template>
    </b-modal>

    <Register :showorg="false" :params="this.params" :register="this.orgs" :links="links" @change="regOrgs"></Register>
  </div>


</template>


<script>

import Register from "@/components/base/Register";
import Enums from "@/components/base/Enums";
import {mapGetters} from "vuex";

export default {
  name: 'Orgs',
  components: {
    Register,
    Enums
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (event, id) => {
      event;
      if (id == 'modal-orgs') {
        this.regOrgs();
      }

    })
  },
  data: function () {
    return {
      links: [
        {name: 'Справочник подразделений', link: '/registers/groups/', icon: 'mdi mdi-domain'},
        {name: 'Справочник сотрудников', link: '/registers/workers/', icon: 'mdi mdi-account-group'},
      ],
      params: {
        name: 'orgs',
        title: 'Организации',
        icon: 'mdi mdi-domain',
        table: 'reg_organizations',
        order: ' ORDER BY name ASC',
        addnew: 'Добавить новую организацию',
        org: false,
        fields: [
          {name: 'ID', model: 'id', type: 'int'},
          {name: 'Наименование организации', model: 'name', type: 'string', required: true, show: true, print: true},
          {name: 'ИИН/БИН', model: 'iinbin', type: 'string', required: false, min: 12, max: 12, show: true, print: true},
          {name: 'Тип организации', model: 'type', type: 'int', required: true, default: 1, print: true},
          {name: 'Налоговый режим', model: 'mode', type: 'int', required: true, default: 1, print: true},
          {name: 'КБе', model: 'kbe', type: 'string', required: false, min: 2, max: 2, print: true},
          {name: 'Банк', model: 'bank_id', type: 'int', required: false, default: 0},
          {name: 'ИИК', model: 'iik', type: 'string', required: false, min: 20, max: 20, print: true},
          {name: 'Счет поступления', model: 'iik_salary', type: 'string', required: false, min: 20, max: 20, print: true},
          {name: 'Руководитель', model: 'chief', type: 'string', required: false, print: true},
          {name: 'Главный бухгалтер', model: 'accountant', type: 'string', required: false, print: true},
          {name: 'Индекс', model: 'zip', type: 'string', required: false, min: 6, max: 6, print: true},
          {name: 'Страна', model: 'country', type: 'string', required: false, default: 'Республика Казахстан', print: true},
          {name: 'Область', model: 'region', type: 'string', required: false, print: true},
          {name: 'Населенный пункт', model: 'city', type: 'string', required: false, print: true},
          {name: 'Почтовый адрес', model: 'address', type: 'string', required: false, print: true}
        ],
        task: ['edit', 'delete', 'select'],
        select: ['name']
      }
    }
  },
  methods: {
    regOrgs: function (mode, id) {
      this.$store.commit('wait', {state: true, name: 'Справочник организаций'});
      this.$http
          .post(this.$apiold, {
            task: 'list',
            mode: mode,
            id: id,
            params: this.params,
            data: this.orgs.current
          })
          .then(response => {
            this.$store.commit('wait', {state: false});
            this.$store.commit('user', response.data.user);

            this.$store.commit('regChange', {name: this.params.name, register: response.data.register});

            if (response.data.modal) {
              this.$bvModal.show('modal-orgs');
            } else {
              this.$bvModal.hide('modal-orgs');
            }


            // Сообщения
            this.$store.commit('alert', response.data.messages);
          });
    }

  },
  created: function () {
    this.regOrgs();
  },
  computed: {
    ...mapGetters({
      changed: 'changed',
      orgs: 'orgs'
    })
  },
  watch: {
    orgs() {
      if (this.orgs.changed) {
        this.regOrgs();
      }
    },
    changed() {
      this.regOrgs();
    },
  }
}
</script>


<style>

</style>
